import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@infrastructure/api/client'
import { ENDPOINTS } from '@infrastructure/api/endpoints'
import { mapTenantsResponse } from '@application/services/tenantMapper'
import { tenantActions } from '@store/tenantStore'
import { TENANT_QUERY_KEYS } from './queryKeys'

export const useTenants = () => {
  return useQuery({
    queryKey: TENANT_QUERY_KEYS.list,
    queryFn: async () => {
      const raw = await httpClient.get(ENDPOINTS.USM.ADMIN.TENANTS.LIST)
      const result = mapTenantsResponse(raw)
      if (!result) throw new Error('Failed to parse tenants response')
      tenantActions.setTenants(result.items)
      return result.items
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })
}
